import React, { useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'relay-runtime';

import { CHARGE_STATUS_ENUM } from '@woovi/shared';

import type { PaymentProvider_charge$key } from './__generated__/PaymentProvider_charge.graphql.ts';
import type { PaymentProvider_subscription$key } from './__generated__/PaymentProvider_subscription.graphql.ts';
import PaymentContext from './PaymentContext.tsx';

type Props = {
  children: React.ReactNode;
  charge: PaymentProvider_charge$key;
  pixAutomatic: PaymentProvider_subscription$key;
  shouldRedirect?: boolean;
};

const PaymentProvider = (props: Props): ReactNode => {
  const [renderITPBanks, setRenderITPBanks] = useState(false);
  const [startRedirect, setStartRedirect] = useState(false);

  const charge = useFragment(
    graphql`
      fragment PaymentProvider_charge on Charge {
        status
        redirectUrl
        isShopifyCharge
      }
    `,
    props.charge,
  );

  const pixAutomatic = useFragment(
    graphql`
      fragment PaymentProvider_subscription on PaymentSubscription {
        redirectUrl
        isActive
      }
    `,
    props.pixAutomatic,
  );

  const initialStatus = useRef(charge?.status);

  useEffect(() => {
    if (!props.shouldRedirect && !charge?.isShopifyCharge) {
      return;
    }

    if (
      initialStatus.current !== charge?.status &&
      charge?.status === CHARGE_STATUS_ENUM.COMPLETED
    ) {
      setStartRedirect(true);
    }

    if (pixAutomatic?.isActive && pixAutomatic?.redirectUrl) {
      setStartRedirect(true);
    }
  }, [charge, pixAutomatic]);

  return (
    <PaymentContext.Provider
      value={{
        renderITPBanks,
        setRenderITPBanks,
        startRedirect,
      }}
    >
      {props.children}
    </PaymentContext.Provider>
  );
};

export default PaymentProvider;
